import {
    SET_LOCATION
} from './types';

export const setLocation = (data) => {
    return {
        type:SET_LOCATION,
        payload:data
    }
}
